import { Phone, CalendarCheck } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function FloatingActions() {
  const { pathname } = useLocation();

  // Hide on legal pages
  if (pathname.startsWith("/legal") || pathname === "/lexique") return null;

  const scrollToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end">
      <button
        onClick={scrollToContact}
        className="flex items-center gap-2 bg-cta text-cta-foreground px-4 py-2.5 rounded-full shadow-lg hover:bg-cta/90 transition-all text-sm font-semibold font-body normal-case"
      >
        <CalendarCheck size={18} />
        Réserver
      </button>
      <a
        href="tel:0624357716"
        className="flex items-center justify-center bg-gold text-white w-10 h-10 rounded-full shadow-lg hover:bg-gold/90 transition-all"
        aria-label="Nous appeler"
      >
        <Phone size={18} />
      </a>
    </div>
  );
}